import { UpiPaymentDetailDto } from './upi-payment-detail-dto';

export class UpiPaymentDto {

    upiPaymentDetailDto: UpiPaymentDetailDto[];
}
